/* eslint-disable object-shorthand */
import React, { Component, useState } from 'react'
import ReactApexChart from 'react-apexcharts'
import dayjs from 'dayjs'

export default function SteamUnit({ valueSumSteam }) {
  const [tickAmount, setTickAmount] = useState(valueSumSteam?.length)
  const [valueFormat, setValueFormat] = useState('DD MMM')
  console.log('valueSumSteam', valueSumSteam)
  const series = [
    {
      name: 'ปริมาณไอน้ำที่ผลิตได้',
      type: 'column',
      data: valueSumSteam,
    },
  ]
  const options = {
    chart: {
      height: 350,
      type: 'line',
    },
    stroke: {
      width: [0, 4],
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: [1],
    },

    xaxis: {
      type: 'datetime',
      labels: {
        formatter: (value) => dayjs(value).locale('th').format(valueFormat),
      },
      tickAmount,
    },
    yaxis: [
      {
        title: {
          text: 'ปริมาณไอน้ำที่ผลิตได้',
        },
        labels: {
          formatter: function (val) {
            return val
          },
        },
      },
    ],
  }

  return (
    <div id="chart">
      <ReactApexChart
        options={options}
        series={series}
        type="line"
        height={350}
      />
    </div>
  )
}
